import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';

class CandidateRaterState {
  store = new DomainStore();

  score;
  onRating;
  mousedOverStar = false;
  mousedOverStarIndex;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({onRating, score}) {
    this.onRating = onRating;
    this.score = score;
  }

  onStarMouseEnter(i) {
    if (!this.onRating) {
      return;
    }

    this.mousedOverStar = true;
    this.mousedOverStarIndex = i;
  }

  onStarMouseLeave() {
    if (!this.onRating) {
      return;
    }

    this.mousedOverStar = false;
  }

  async rateCandidate(score) {
    if (!this.onRating) {
      return;
    }

    this.onRating(score);
  }

  get scoreToDisplay() {
    return this.mousedOverStar ? this.mousedOverStarIndex : this.score;
  }
}

export default CandidateRaterState;
